
export function encodeCacheKey(value: string) {
  return btoa(unescape(encodeURIComponent(value)));
}
